import { differenceInYears, parseISO } from "date-fns";

/**
 * Calcula la edad a partir de una fecha de nacimiento en formato ISO.
 * @param fechaNacimiento string en formato ISO (ej. '1995-10-18T00:00:00Z')
 * @returns number Edad actual
 */
export const getEdad = (fechaNacimiento) => {
  const fecha = parseISO(fechaNacimiento);
  return differenceInYears(new Date(), fecha);
};
